/**
 * 微信内置浏览器分享
 * urlhead :'http://localhost:10011'
 */
const wechat ={
	 urlhead :'/ribao',
	//获取js_ticket值
	title : '',
	linkd : '',
	desc : '',
	imgUrl : '',
	timestamp1:'',
	nonceStr1:'',
	signature1:'',
	appid:'',
   getJsticket (title,linkd,desc,imgUrl){
   	var that = this;
   	that.title = title;
   	that.linkd = linkd;
   	that.desc = desc;
   	if(imgUrl == ""){
   		if(location.href.split('#')[0].indexOf("?")!=-1){
   			var ordhref = location.href.split('#')[0];
   			that.imgUrl = ordhref.split('?')[0]+"logo.png";
   		}else{
   			that.imgUrl = location.href.split('#')[0]+"logo.png";
   		}
   	}else{
   		that.imgUrl = imgUrl;
   	}
    	$.ajax({
			type:"GET",
			url:this.urlhead+"/api/wechat/getWeChatTicket",
			contentType:"application/json;charset=utf-8",
			dataType:"json",
			
			data: {url:encodeURIComponent(location.href.split('#')[0])}
		})
		.done(function(_data){
			console.log(_data);
			that.appid = _data.data.appid;
			that.signature1 =_data.data.signature;
			that.timestamp1 = _data.data.timestamp;
			that.nonceStr1 = _data.data.nonce;
			that.clickShareWeixin()
		})
		.fail(function(){

		})
	},
	//通过config接口注入权限验证配置
	clickShareWeixin(){
		var that = this;
		console.log("/////"+that.appid)
		wx.config({
		    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		    appId: that.appid, // 必填，公众号的唯一标识 ;生产：wx518f6ac1c229a2b8      测试：wxdc473423951afd89
		    timestamp: that.timestamp1, // 必填，生成签名的时间戳
		    nonceStr: that.nonceStr1, // 必填，生成签名的随机串
		    signature: that.signature1,// 必填，签名，见附录1
		    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','chooseImage',
		                'uploadImage','onMenuShareQQ','onMenuShareWeibo','onMenuShareQZone','getLocation'],  // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
		    openTagList: ['wx-open-launch-weapp','wx-open-launch-app']
			});
		//ready方法
		wx.ready(function(){
			/***
			 * 分享到朋友圈
			 */
			//分享链接生产
			wx.onMenuShareTimeline({
			    title: that.title, // 分享标题
			    link: that.linkd, // 分享链接
			    desc: that.desc,
			    imgUrl: that.imgUrl, // 分享图标
			    type: '', // 分享类型,music、video或link，不填默认为link
			    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
			    success: function () { 
			    },
			    cancel: function () { 
			        // 用户取消分享后执行的回调函数
			    }
			});
			wx.onMenuShareAppMessage({
				title: that.title, // 分享标题
				link: that.linkd, // 分享链接
			    desc: that.desc,
			    imgUrl: that.imgUrl, // 分享图标
			    type: '', // 分享类型,music、video或link，不填默认为link
			    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
			    success: function () { 
			    },
			    cancel: function () { 
			        // 用户取消分享后执行的回调函数
			    }
			});
			wx.onMenuShareQQ({
				title: that.title, // 分享标题
				link: that.linkd, // 分享链接
				desc: that.desc,
				imgUrl: that.imgUrl, // 分享图标
				type: '', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () { 
				},
				cancel: function () { 
					// 用户取消分享后执行的回调函数
				}
			});
			wx.onMenuShareWeibo({
				title: that.title, // 分享标题
				link: that.linkd, // 分享链接
				desc: that.desc,
				imgUrl: that.imgUrl, // 分享图标
				type: '', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () { 
				},
				cancel: function () { 
					// 用户取消分享后执行的回调函数
				}
			});
			wx.onMenuShareQZone({
				title: that.title, // 分享标题
				link: that.linkd, // 分享链接
				desc: that.desc,
				imgUrl: that.imgUrl, // 分享图标
				type: '', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () { 
				},
				cancel: function () { 
					// 用户取消分享后执行的回调函数
				}
			});
			
		});		
		wx.error(function(res){
		    // config信息验证失败会执行error函数，如签名过期导致验证失败，
			//具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		});
	}

}
export default wechat




// WEBPACK FOOTER //
// ./src/assets/js/wechat.js